export default "__VITE_ASSET__BBFSTRtx__"